import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import LegalLayout, { LegalSection, LegalList } from "../components/LegalLayout";

export default function Privacy() {
    return (
        <>
            <Seo
                title="Privacy Policy"
                path="/privacy"
                description="ezBuildABot Privacy Policy — how we collect, use, and protect the information you share with us through our website and contact forms."
            />
            <LegalLayout
                eyebrow="Legal"
                title="Privacy Policy"
                updated="June 9, 2026"
                intro="This Privacy Policy explains how ezBuildabot, a service of Gadget Guy Media (“we,” “us,” or “our”), collects, uses, and safeguards the information you provide when you visit ezbuildabot.com or contact us."
            >
                <LegalSection title="1. Who we are">
                    <p>
                        ezBuildabot is a custom AI development studio operated by Gadget Guy
                        Media, based in Gallatin, Tennessee, USA. If you have any questions about
                        this policy or your data, you can reach us at{" "}
                        <a
                            href="mailto:info@ezbuildabot.com"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            info@ezbuildabot.com
                        </a>
                        .
                    </p>
                </LegalSection>

                <LegalSection title="2. Information we collect">
                    <p>
                        We only collect the information you choose to give us. When you submit a
                        contact form, request a quote, or book a call, we may collect:
                    </p>
                    <LegalList
                        items={[
                            "Your name",
                            "Your email address",
                            "Your company name (optional)",
                            "The details of your project or message",
                        ]}
                    />
                    <p>
                        We may also automatically collect basic, non-identifying usage data
                        (such as pages visited and general device/browser information) to help us
                        understand how the site is used and to improve it.
                    </p>
                </LegalSection>

                <LegalSection title="3. How we use your information">
                    <p>We use the information you provide to:</p>
                    <LegalList
                        items={[
                            "Respond to your inquiry and provide a quote or proposal",
                            "Communicate with you about your project or our services",
                            "Send you a confirmation or follow-up email after you contact us",
                            "Operate, maintain, and improve our website and services",
                        ]}
                    />
                    <p>
                        We do not sell, rent, or trade your personal information to third parties.
                    </p>
                </LegalSection>

                <LegalSection title="4. How we share information">
                    <p>
                        We share information only with trusted service providers who help us
                        operate our business — for example, our email delivery provider
                        (SendGrid) used to send and receive correspondence, and our hosting and
                        database infrastructure used to store form submissions. These providers
                        are only permitted to use your information to perform services on our
                        behalf. We may also disclose information if required to do so by law.
                    </p>
                </LegalSection>

                <LegalSection title="5. Data retention">
                    <p>
                        We retain the information you submit for as long as necessary to respond
                        to your inquiry, fulfill the purposes described in this policy, and meet
                        our legal or business obligations. You may request deletion of your
                        information at any time by emailing us.
                    </p>
                </LegalSection>

                <LegalSection title="6. Cookies and analytics">
                    <p>
                        Our website may use cookies and similar technologies to keep the site
                        functioning and to gather aggregate analytics about site usage. You can
                        control or disable cookies through your browser settings, though some
                        parts of the site may not function as intended without them.
                    </p>
                </LegalSection>

                <LegalSection title="7. Data security">
                    <p>
                        We take reasonable technical and organizational measures to protect the
                        information you share with us. However, no method of transmission over the
                        internet or electronic storage is completely secure, and we cannot
                        guarantee absolute security.
                    </p>
                </LegalSection>

                <LegalSection title="8. Your rights">
                    <p>
                        Depending on where you live, you may have the right to access, correct, or
                        delete the personal information we hold about you, or to object to certain
                        processing. To exercise any of these rights, contact us at{" "}
                        <a
                            href="mailto:info@ezbuildabot.com"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            info@ezbuildabot.com
                        </a>
                        .
                    </p>
                </LegalSection>

                <LegalSection title="9. Children's privacy">
                    <p>
                        Our website and services are intended for businesses and individuals aged
                        18 and over. We do not knowingly collect personal information from
                        children.
                    </p>
                </LegalSection>

                <LegalSection title="10. Changes to this policy">
                    <p>
                        We may update this Privacy Policy from time to time. When we do, we will
                        revise the “Last updated” date at the top of this page. We encourage you
                        to review this page periodically.
                    </p>
                </LegalSection>

                <LegalSection title="11. Contact us">
                    <p>
                        If you have any questions or concerns about this Privacy Policy or how we
                        handle your information, please email{" "}
                        <a
                            href="mailto:info@ezbuildabot.com"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            info@ezbuildabot.com
                        </a>{" "}
                        or reach out through our{" "}
                        <Link
                            to="/contact"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            contact page
                        </Link>
                        .
                    </p>
                </LegalSection>
            </LegalLayout>
        </>
    );
}
